
import Clarity from '@microsoft/clarity';
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { CLARITY_PROJECT_ID } from '../../project_config';

export default function NotFound() {
    Clarity.init(CLARITY_PROJECT_ID);

    return (
        <>
            <Helmet>
                <title>404 | همراهتیم</title>
                <meta name="description" content="صفحه مورد نظر یافت نشد همراهتیم" />
            </Helmet>

            <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
                <h1 className="text-9xl font-bold text-darkBlue">404</h1>
                <h2 className="text-2xl font-Vazir-600 text-midGray mt-4 mb-8">صفحه مورد نظر یافت نشد!</h2>
                <div className="w-[150px] h-[40px]">
                    <Link
                        to="/"
                        className="w-full h-full flex flex-row items-center justify-center bg-[#ff694b] font-Vazir-600 text-[#ffffff] rounded-[10px] cursor-pointer">
                        بازگشت به خانه
                    </Link>
                </div>
            </div>
        </>
    );
};
